import { OutdoorEngagementResolutionCategory } from '../../../../../api/models'
import { accessNotAllowed, disallowedReasonMessages } from '../../ErtPreprocessor'

export const getDisallowedReasonMessage = (disallowedReason: string | undefined): string =>
  (disallowedReason ? disallowedReasonMessages[disallowedReason] : undefined) ?? accessNotAllowed

export const noSpecialistAssignedTitle = 'No specialist was ever assigned to this engagement'

/**
 * Why an engagement was never handled. Museum reports a single `Abandoned/EngagementAbandoned` on the
 * assignment activity for three different upstream causes, so the activity alone can't say which one -
 * the engagement's own resolution category can.
 */
export const unhandledCauseMessages: Partial<Record<OutdoorEngagementResolutionCategory, string>> = {
  [OutdoorEngagementResolutionCategory.Obsolete]: 'It went more than 15 minutes without being assigned and was cleared automatically as obsolete.',
  [OutdoorEngagementResolutionCategory.ClearedByCustomer]: 'The customer disarmed before a specialist picked it up.',
  [OutdoorEngagementResolutionCategory.ClearedByAI]: 'AI review cleared it before it reached a specialist.',
  [OutdoorEngagementResolutionCategory.ClearedBySystemTriage]: 'System triage cleared it before it reached a specialist.',
  [OutdoorEngagementResolutionCategory.IntrusionMonitoringTakeover]: 'An intrusion specialist took over the alarm for this location.',
  [OutdoorEngagementResolutionCategory.NoVideoAvailable]: 'No video loaded for the engagement.'
}
